// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"db23be3c","57":"0eb2072c","124":"1395b4ff","353":"496a5887","449":"779db32a","453":"87e45203","660":"dff304d2","697":"9d3aaf3b","712":"a7586ba3","819":"9d9f3014"}[chunkId] + ".chunk.js";
};